// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bouncing-dot {
  display: inline-block;
  animation-name: bouncing-dot-bounce;
  animation-duration: 700ms;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

.bouncing-dot:nth-child(2) {
  animation-delay: 125ms;
}

.bouncing-dot:nth-child(3) {
  animation-delay: 250ms;
}

@keyframes bouncing-dot-bounce {
  0% {
    transform: none;
  }

  33% {
    transform: translateY(-0.2em);
  }

  66% {
    transform: none;
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
